import React, { useMemo } from 'react'
import { Grid, Typography, Paper, useMediaQuery, Theme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { getProductByRedirectUrl } from '../products/Products'
import { useLocation } from 'react-router-dom'

interface ExternSurfaceProps {
    title: string
    description?: string
    children: React.ReactNode
}

const LogoImg = styled('img')(({ theme }) => ({
    marginBottom: theme.spacing(4),
}))

export default function ExternSurface({
    title,
    description,
    children,
}: ExternSurfaceProps) {
    const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
    const qs = useLocation().search
    const query = useMemo(() => new URLSearchParams(qs), [qs])
    const product = useMemo(
        () => getProductByRedirectUrl(query.get('continue') ?? ''),
        [query]
    )

    return (
        <Grid item xs={12} sm={10} md={6} lg={4} xl={3}>
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={11} lg={12}>
                    <Paper
                        variant="outlined"
                        sx={(theme) => {
                            return {
                                padding: theme.spacing(isSm ? 2 : 5),
                            }
                        }}
                    >
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item xs="auto">
                                <LogoImg
                                    src={
                                        product?.imageUrl ??
                                        '/focaltec_horizontal.png'
                                    }
                                    alt={product?.imageAlt() ?? ''}
                                />
                            </Grid>
                        </Grid>
                        {title && (
                            <Typography
                                component="h6"
                                variant="h6"
                                align="center"
                                gutterBottom
                            >
                                {title}
                            </Typography>
                        )}
                        {description && (
                            <Typography
                                variant="body2"
                                align="center"
                                gutterBottom
                                paragraph
                            >
                                {description}
                            </Typography>
                        )}
                        {children}
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    )
}
